import CallServiceTable from "../../../components/Tables/CallServiceTable";
import Button from "../../../components/Buttons/Button";
import { useModal } from "../../../contexts/ModalContext";
import { useDialog } from "../../../contexts/DialogContext";
import CompanyDetail from "../../../containers/menu/manageCompany/CompanyDetail";
import CreateCompany from "../../../containers/menu/manageCompany/CreateCompany";
import ImportClient from "../../../containers/menu/manageCompany/ImportClient";
import RenderPDFClient from "../../../containers/menu/manageCompany/RenderPDFClient";
import SendAnnouncement from "../../announcements/SendAnnouncement";

const ManageCompany = () => {
  const { openModal, onClose } = useModal();
  const { openDialog } = useDialog();

  function handleSendEmail(reload) {
    openModal(<SendAnnouncement reload={reload} onClose={onClose} />);
  }
  
  function handleImport(reload) {
    openModal(<ImportClient reload={reload} onClose={onClose} />);
  }

  function handleNewCompany(reload) {
    openModal(<CreateCompany reload={reload} onClose={onClose} handleGetCompany={handleGetCompany} />);
  }

  function handleGetCompany(company, reload) {
    openModal(
      <CompanyDetail companyID={company.id} reload={reload} onClose={onClose} />
    );
  }

  function handleDocumentPdf(data) {
    openDialog(<RenderPDFClient company={data} />);
  }

  // function handleDocumentPdf(data) {
  //   openDialog(<RenderPDFClient company={data} dialogClose={dialogClose} />);
  // }

  return (
    <CallServiceTable
      onClick={handleGetCompany}
      urlApi="/company"
      component={({ reload }) => {
        return (
          <>
            {/* <Button onClick={() => handleSendEmail(reload)} className='px-2 py-3 text-base  flex-nowrap whitespace-nowrap'>
              Boletín informativo <i className="far fa-envelope"></i>
            </Button>
            <Button onClick={() => handleImport(reload)} className='px-2 py-3 text-base  flex-nowrap whitespace-nowrap'>
              Importar <i className="fas fa-arrow-up-from-bracket"></i>
            </Button> */}
            <Button onClick={() => handleNewCompany(reload)} className='px-2 py-3 text-base flex-nowrap whitespace-nowrap'>
              Crear compañía <i className="fa-solid fa-plus"></i>
            </Button>
          </>
          
        );
      }}
      header={[
        {
          name: "razonSocial",
          label: "Compañía",
          filter: true,
        },
        {
          name: "nit",
          label: "NIT",
          filter: true,
        },
        {
          name: "accountCode",
          label: "Nro. de cuenta",
          filter: true,
        },
        {
          name: "categoria",
          label: "Categoria",
          filter: false,
        },
        {
          name: "status",
          label: "Estado",
          filter: false,
        },
        {
          name: "Reports",
          type: "action",
          label: "Reporte",
          actions: [
            {
              label: "Imprimir datos del cliente",
              icon: "fas fa-print",
              action: handleDocumentPdf,
              color: "text-[#1d4ed8] pl-3",
            },
          ],
        },
      ]}
      filters={[
        {
          name: "category",
          label: "Todas las categorías",
          options: [
            {
              label: "AA",
              name: "AA",
            },
            {
              label: "A",
              name: "A",
            },
            {
              label: "B",
              name: "B",
            },
            {
              label: "C",
              name: "C",
            },
          ],
        },
        {
          name: "inCharge",
          label: "Todos los encargados",
          url: "/Dropdown/rol_InCharge/options",
          valueOption: "id",
          labelOption: "name",
        },
        {
          name: "commercialActivity",
          label: "Tipo de mercancía",
          url: "/dropdown/tiposMeMercaderia/options",
          value: "name",
          labelOption: "name",
        },
        {
          name: "ciudad",
          label: "Todas las ciudades",
          options: [
            {
              label: "Santa Cruz",
              name: "Santa Cruz",
            },
            {
              label: "La Paz",
              name: "La Paz",
            },
            {
              label: "Cochabamba",
              name: "Cochabamba",
            },
            {
              label: "Chuquisaca",
              name: "Chuquisaca",
            },
            {
              label: "Oruro",
              name: "Oruro",
            },
            {
              label: "Tarija",
              name: "Tarija",
            },
            {
              label: "Beni",
              name: "Beni",
            },
            {
              label: "Pando",
              name: "Pando",
            },
            {
              label: "Potosí",
              name: "Potosí",
            },
          ],
        },
      ]}
      addUrl={`userId=${localStorage.getItem("id")}`}
      showTable={false}
      indexSelectedRef='id'
    />
  );
};

export default ManageCompany;
